import axios from 'axios'
import Cookies from 'js-cookie'

export const service = sessionStorage.getItem('service');
let baseURL;

if (service === 'glo') {
  baseURL = 'https://glo-backend.qwizfun.com';
} else {
  baseURL = 'https://gameapi.9ijakids.com';
}

export const instance = axios.create({
  baseURL: baseURL,
});

instance.interceptors.request.use((config) => {
  let accessToken = Cookies.get('access_token')

  
  if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`
  }
  return config
})
